import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import $api from "../index";
import { TRizdvoniki } from "../../types/rizdvoniki";

const API_URL = "https://api.pipe.bot/user/count";
const API_KEY_FOR_TELEGRAM_BOT = "65d3b95030ed6258c8a70fb7b5a2e88a";

// export const getRizdvoniki = createAsyncThunk(
//   "getRizdvoniki",
//   async (_, { rejectWithValue }): Promise<TRizdvoniki> => {
//     try {
//       const response = await $api.get(`${API_URL}`, {
//         params: {
//           apikey: API_KEY_FOR_TELEGRAM_BOT,
//           segment: "?textwishes",
//         },
//       });
//       return response.data;
//     } catch (e: any | AxiosError) {
//       if (axios.isAxiosError(e)) {
//         const axiosError = e as AxiosError;
//         throw rejectWithValue(axiosError);
//       }
//       throw rejectWithValue(e.message);
//     }
//   }
// );

export const getRizdvonikiUsers = createAsyncThunk(
  "getRizdvonikiUsers",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await $api.get(
        "https://sheetdb.io/api/v1/tul8822nam8x0"
      );
      return response.data;
    } catch (e: any | AxiosError) {
      const axiosError = e as AxiosError;
      console.log(axiosError);
      if (axios.isAxiosError(e)) {
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
